export default "__VITE_ASSET__b306349c__"